import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"


function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("cal-root", className)}
      classNames={{
        months: "cal-months",
        month: "cal-month",
        caption: "cal-caption",
        caption_label: "cal-caption-label",
        nav: "cal-nav",
        nav_button: "cal-nav-btn",
        nav_button_previous: "cal-nav-prev",
        nav_button_next: "cal-nav-next",
        table: "cal-table",
        head_row: "cal-head-row",
        head_cell: "cal-head-cell",
        row: "cal-row",
        cell: "cal-cell",
        day: "cal-day",
        day_range_start: "cal-day-range-start",
        day_range_end: "cal-day-range-end",
        day_selected: "cal-day-selected",
        day_today: "cal-day-today",
        day_outside: "cal-day-outside",
        day_disabled: "cal-day-disabled",
        day_range_middle: "cal-day-range-middle",
        day_hidden: "cal-day-hidden",
        ...classNames,
      }}
      components={{
        IconLeft: ({ className, ...props }) => (
          <ChevronLeft className={cn("h-4 w-4", className)} {...props} />
        ),
        IconRight: ({ className, ...props }) => (
          <ChevronRight className={cn("h-4 w-4", className)} {...props} />
        ),
      }}
      {...props} />
  );
}
Calendar.displayName = "Calendar"

export { Calendar }
